import Footer from '../../components/Footer';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Container, GamesContainer, Row } from './styles';
import { Card as CustomCard } from './components/Card';
import { Header } from './components/Header';
import { useEffect, useState } from 'react';
import { apiNode } from '../../services/api';
import { Card } from 'antd';
import { LeaveLeagueModal } from './components/LeaveLeagueModal';

interface LeagueParticipants {
  id: number;
  userId: number;
  ligaId: number;
  isAdmin: boolean;
  pontos: number;
  createdAt: string;
  username: string;
  foto: string;
}

interface LeagueProps {
  nome: string;
  participantes_ligas: LeagueParticipants[];
}

interface LeagueListProps {
  updateHasLeague: () => Promise<void>;
}

export const LeaguesList: React.FC<LeagueListProps> = ({
  updateHasLeague,
}: LeagueListProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [league, setLeague] = useState<LeagueProps>();
  const [isAdmin, setIsAdmin] = useState(false);

  const [isLeaveLeagueModalOpen, setIsLeaveLeagueModalOpen] = useState(false);

  useEffect(() => {
    try {
      setIsLoading(true);
      const getParticipants = async () => {
        const leagueData = await apiNode.get('/ligas/users');

        const response = await apiNode.get(`/ligas/${leagueData.data.liga.id}`);

        setIsAdmin(leagueData.data.participante.isAdmin);
        setLeague(response.data.liga);
        setIsLoading(false);
      };

      getParticipants();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, []);

  return (
    <Container>
      <Header
        isAdmin={isAdmin}
        openLeaveLeagueModal={() => setIsLeaveLeagueModalOpen(true)}
      />
      <GamesContainer>
        <Row>
          <h2>Liga: {isLoading ? '........' : league?.nome}</h2>
          <div>
            {isLoading && (
              <>
                <Card
                  loading={true}
                  style={{ width: '80%', marginRight: 36 }}
                />
                <Card
                  loading={true}
                  style={{ width: '80%', marginRight: 36 }}
                />
                <Card
                  loading={true}
                  style={{ width: '80%', marginRight: 36 }}
                />
              </>
            )}
            {!isLoading &&
              league?.participantes_ligas.map((participant) => (
                <CustomCard key={participant.id} participant={participant} />
              ))}
          </div>
        </Row>
      </GamesContainer>
      <Footer />
      <LeaveLeagueModal
        isOpen={isLeaveLeagueModalOpen}
        closeModal={() => setIsLeaveLeagueModalOpen(false)}
        updateHasLeague={updateHasLeague}
      />
    </Container>
  );
};
